"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const intent_1 = require("../constants/intent");
const Div_1 = require("../elements/Div");
const Icon_1 = require("../elements/Icon");
const Tooltip_1 = require("../elements/Tooltip");
const TooltipIconAnchor = (0, styled_1.default)(Div_1.Div)({
    width: 'fit-content',
});
const TooltipIcon = ({ text, tooltipIntent, color, backgroundColor, iconName, size, design, ...divProps }) => {
    const { backgroundColor: intentBackgroundColor, iconName: intentIconName, color: intentColor, } = (0, intent_1.getIntentProps)(tooltipIntent ?? 'info');
    return ((0, jsx_runtime_1.jsx)(Tooltip_1.Tooltip, { text: text, intent: tooltipIntent, children: (0, jsx_runtime_1.jsx)(Tooltip_1.Tooltip.Trigger, { asChild: true, children: (0, jsx_runtime_1.jsx)(TooltipIconAnchor, { ...divProps, children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: iconName ?? intentIconName, color: color ?? intentColor, backgroundColor: backgroundColor ?? intentBackgroundColor, size: size, design: design }) }) }) }));
};
exports.TooltipIcon = TooltipIcon;
